import { render, staticRenderFns } from "./BranchRecap.vue?vue&type=template&id=e333334a"
import script from "./BranchRecap.vue?vue&type=script&lang=js"
export * from "./BranchRecap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports